import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import AssociationForm from './AssociationForm';
import ConfirmationModal from '../../../Modal/ConfirmationModal';
import {
  getMandatairesByAccount,
  deleteMandataire,
} from '../../../service/api/AssociationService';

const TableauAssociation = ({ account = {}, accountId, domainId, onClose }) => {
  const [mandataires, setMandataires] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editingMandataire, setEditingMandataire] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [mandataireToDelete, setMandataireToDelete] = useState(null);

  // Récupérer les mandataires pour un compte spécifique
  const fetchMandataires = async () => {
    try {
      const data = await getMandatairesByAccount(accountId, domainId);
      setMandataires(data);
    } catch (error) {
      toast.error('Erreur lors de la récupération des mandataires');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (accountId) fetchMandataires();
  }, [accountId]);

  // Gérer l'édition d'un mandataire
  const handleEdit = (mandataire) => {
    setEditingMandataire(mandataire);
    setShowForm(true);
  };

  // Gérer la suppression d'un mandataire
  const handleDeleteClick = (mandataire) => {
    setMandataireToDelete(mandataire);
    setShowConfirmationModal(true);
  };

  const confirmDelete = async () => {
    if (!mandataireToDelete) return;
    try {
      await deleteMandataire(mandataireToDelete.id);
      toast.success('Mandataire supprimé avec succès');
      fetchMandataires();
    } catch (error) {
      toast.error('Erreur lors de la suppression du mandataire');
    } finally {
      setShowConfirmationModal(false);
      setMandataireToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowConfirmationModal(false);
    setMandataireToDelete(null);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingMandataire(null);
  };

  const handleSuccessForm = () => {
    fetchMandataires();
    handleCloseForm();
  };

  if (showForm) {
    return (
      <AssociationForm
        account={account}
        accountId={accountId}
        editingMandataire={editingMandataire}
        onClose={handleCloseForm}
        onSuccess={handleSuccessForm}
      />
    );
  }

  return (
    <div className="modal modal fade show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-custom">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Mandataires pour {' '}
              <strong className="text-primary">{account.companyName}</strong>
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {isLoading ? (
              <p>Chargement...</p>
            ) : (
           <div className="table-responsive">
              <table className="table table-striped align-middle">
                <thead>
                  <tr>
                    <th>Prénom</th>
                    <th>Nom</th>
                    <th>Téléphone</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {mandataires.length > 0 ? (
                    mandataires.map((mandataire) => (
                      <tr key={mandataire.id}>
                        <td>{mandataire.firstName}</td>
                        <td>{mandataire.lastName}</td>
                        <td>{mandataire.telephone}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary me-2"
                            onClick={() => handleEdit(mandataire)}
                            data-tooltip-id={`edit-${mandataire.id}`}
                            data-tooltip-content="Modifier"
                          >
                            ✎
                            <Tooltip id={`edit-${mandataire.id}`} place="top" effect="solid" />
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDeleteClick(mandataire)}
                            data-tooltip-id={`delete-${mandataire.id}`}
                            data-tooltip-content="Supprimer"
                          >
                            🗑
                            <Tooltip id={`delete-${mandataire.id}`} place="top" effect="solid" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        Aucun mandataire trouvé pour ce compte.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              </div>
            )}
          </div>
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          message={`Êtes-vous sûr de vouloir supprimer ${mandataireToDelete.firstName} ${mandataireToDelete.lastName} ? Cette action est irréversible.`}
          onConfirm={confirmDelete}
          onCancel={cancelDelete}
        />
      )}
    </div>
  );
};

export default TableauAssociation;